<template>
  <div v-if="!isLoadingData">
    <div class="d-flex justify-content-between p-3 p-sm-0 mb-3">
      <h1 class="mb-0 header-main text-uppercase d-inline">CHAT SETTING</h1>
    </div>
    <div class="bg-white-border p-3 main-theme">
      <p class="my-2 dropdown-date-custom-text">Assign Chat</p>
      <b-row>
        <b-col cols="12">
          <b-form-radio class="my-2" v-model="form.assignChatId" :value="1">
            All
          </b-form-radio>
          <b-form-radio class="my-2" v-model="form.assignChatId" :value="2">
            Team
          </b-form-radio>
        </b-col>
      </b-row>
      <hr class="mt-1" />
      <p class="my-2 dropdown-date-custom-text">Assign New Chat</p>
      <b-row>
        <b-col cols="12">
          <b-form-radio class="my-1" v-model="form.assignNewChatId" :value="1">
            All
          </b-form-radio>
          <div class="d-flex">
            <b-form-radio
              class="my-2"
              v-model="form.assignNewChatId"
              :value="2"
            >
              Specific Team
            </b-form-radio>
            <InputSelect
              v-model="form.roleMappingId"
              title=""
              name="team"
              :options="teamList"
              :disabled="form.assignNewChatId != 2"
              @onDataChange="handleChangeTeam"
              valueField="roleMappingId"
              textField="name"
              class="ml-3"
              :isValidate="$v.form.roleMappingId.$error"
              :v="$v.form.roleMappingId"
            />
          </div>
        </b-col>
      </b-row>
      <hr class="mt-1" />
      <p class="my-2 dropdown-date-custom-text">Assign Agent</p>
      <b-row>
        <b-col cols="12">
          <b-form-checkbox class="my-1" v-model="form.isAssignAgent">
            Show "Always Auto Assign to this Agent" Checkbox
          </b-form-checkbox>
        </b-col>
      </b-row>
      <hr class="my-3" />
      <b-row class="mt-3">
        <b-col md="6" sm="12">
          <UploadImageAndPreview
            imagePath=""
            textFloat="Brand Logo"
            desc="Logo dimension 800x800 not over 1 MB (Please attach file .png only)"
            name="logo"
            v-model="form.brandLogo"
            :value="form.brandLogo"
            @deleteImage="handleDeleteImage"
            @input="handleImageUpload"
          />
        </b-col>
        <b-col md="6" sm="12">
          <UploadImageAndPreview
            imagePath=""
            textFloat="Icon Mobile"
            desc="Logo Mobile not over 1 MB (Please attach file .png only)"
            name="logo"
            v-model="form.favicon"
            :value="form.favicon"
            @deleteImage="handleDeleteImageMobile"
            @input="handleImageMobileUpload"
          />
        </b-col>
      </b-row>
      <hr class="my-3" />
      <p class="my-2 dropdown-date-custom-text">Search Conversation</p>
      <b-row>
        <b-col cols="3">
          <InputNumber
            textFloat=""
            placeholder="search Conversation"
            name="search_conversation"
            v-model="form.daysToSearchConversation"
            :isValidate="$v.form.daysToSearchConversation.$error"
            :v="$v.form.daysToSearchConversation"
          />
        </b-col>
        <p class="d-flex align-items-center justify-content-start">Days</p>
      </b-row>
      <hr class="my-3" />
      <p class="my-2 dropdown-date-custom-text">Chat Template</p>
      <b-row>
        <b-col cols="12">
          <b-form-checkbox class="my-1" v-model="form.isPopupComfirmChat">
            Show Popup Confirm Chat Template
          </b-form-checkbox>
        </b-col>
      </b-row>
      <hr class="mt-2 mb-3" />
      <p class="my-2 dropdown-date-custom-text">Auto Translation</p>
      <b-row class="mb-3">
        <b-col>
          <toggle-button
            class="mt-1 mr-1"
            v-model="form.translationEnable"
            :color="{
              checked: '#27BDA7',
              unchecked: '#B0B0B0',
            }"
          />
        </b-col>
      </b-row>
      <hr class="mt-2 mb-3" />
      <p class="my-2 dropdown-date-custom-text">Number of Ticket</p>
      <b-row>
        <b-col cols="3">
          <InputNumber
            textFloat=""
            placeholder="Total Ticket"
            name="totalticket"
            v-model="form.totalTicket"
            :isValidate="$v.form.totalTicket.$error"
            :v="$v.form.totalTicket"
          />
        </b-col>
        <p class="d-flex align-items-center justify-content-start">Tickets</p>
      </b-row>
      <hr class="mt-2 mb-3" />
      <p class="my-2 dropdown-date-custom-text">Mention</p>
      <b-row>
        <b-col cols="12">
          <b-form-checkbox class="my-1" v-model="form.mentionEnable">
            Enable Mention Function
          </b-form-checkbox>
        </b-col>
      </b-row>
      <hr class="my-3" />
      <p class="my-2 dropdown-date-custom-text">Offline/Online</p>
      <b-row>
        <b-col cols="12">
          <b-form-checkbox class="my-1" v-model="form.adminStatusEnable">
            Enable Offline/Online Function
          </b-form-checkbox>
        </b-col>
      </b-row>
      <hr class="mt-2 mb-3" />
      <p class="my-2 dropdown-date-custom-text">All Closed</p>
      <b-row>
        <b-col cols="12">
          <b-form-checkbox
            class="my-1"
            v-model="form.chatModeTypeAllClosedEnable"
          >
            Enable All Closed
          </b-form-checkbox>
        </b-col>
      </b-row>
      <hr class="mt-2 mb-3" />
      <p class="my-2 dropdown-date-custom-text">Auto Assign Agent</p>
      <b-row>
        <b-col cols="12">
          <b-form-radio class="my-1" v-model="form.autoAssignAgent" :value="0">
            Manual
          </b-form-radio>

          <b-form-radio class="my-2" v-model="form.autoAssignAgent" :value="1">
            Conversation Work Load
          </b-form-radio>
        </b-col>
      </b-row>
      <hr class="mt-2 mb-3" />
      <p class="my-2 dropdown-date-custom-text">Enter to send</p>
      <b-row>
        <b-col cols="12">
          <b-form-checkbox class="my-1" v-model="form.enterToSendEnable">
            Enable Enter to send
          </b-form-checkbox>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" class="text-sm-right">
          <button
            type="button"
            @click="handleSubmit()"
            :disabled="isDisable"
            class="btn btn-main btn-details-set ml-md-2 text-uppercase"
          >
            SAVE
          </button>
        </b-col>
      </b-row>
    </div>
    <ModalLoading ref="modalLoading" :text="msgModal" :hasClose="false" />
  </div>
</template>

<script>
import InputSelect from "@/components/inputs/InputSelect";
import InputNumber from "@/components/inputs/InputNumber";
import { requiredIf, integer, minValue } from "vuelidate/lib/validators";
import ModalLoading from "@/components/modal/alert/ModalLoading";
import UploadImageAndPreview from "@/components/inputs/UploadImageAndPreview";

export default {
  components: { InputSelect, InputNumber, UploadImageAndPreview, ModalLoading },
  data() {
    return {
      isLoadingData: false,
      isDisable: false,
      teamList: [{ roleMappingId: "", name: "Select Team" }],
      msgModal: null,
      form: {
        assignChatId: "",
        assignNewChatId: "",
        totalTicket: "",
        roleMappingId: "",
        isAssignAgent: false,
        isPopupComfirmChat: false,
        mentionEnable: false,
        chatModeTypeAllClosedEnable: false,
        enterToSendEnable: false,
        autoAssignAgent: 0,
      },
      filter: {
        pageNo: 1,
        perPage: 999,
        isActvieOnly: true,
      },
    };
  },
  validations: {
    form: {
      roleMappingId: {
        required: requiredIf(function () {
          return this.form.assignNewChatId == 2;
        }),
      },
      daysToSearchConversation: {
        integer,
        minValue: minValue(0),
      },
      totalTicket: {
        integer,
        minValue: minValue(0),
      },
    },
  },
  watch: {
    "form.assignNewChatId": function (e) {
      if (e == 1) {
        this.form.roleMappingId = "";
        this.$v.form.$reset();
      }
    },
  },
  async mounted() {
    await this.getData();
    await this.getList();
  },
  methods: {
    handleChangeTeam(value) {
      this.form.roleMappingId = value;
    },
    handleImageUpload: async function (value) {
      if (value) this.form.brandLogo = await this.saveImage(value);
      else this.form.brandLogo = "";
    },
    handleImageMobileUpload: async function (value) {
      if (value) this.form.favicon = await this.saveImage(value);
      else this.form.favicon = "";
    },
    saveImage: async function (value) {
      let image = await this.saveImagetoDb(value);
      return image;
    },
    saveImagetoDb: async function (img) {
      var body = {
        base64: img,
      };
      return new Promise((resolve, reject) => {
        this.axios.post(`${this.$baseUrl}/image/save`, body).then((data) => {
          if (data.result == 1) {
            resolve(data.detail.url);
          } else {
            reject(data);
          }
        });
      });
    },
    handleDeleteImage() {
      this.form.brandLogo = null;
    },
    handleDeleteImageMobile() {
      this.form.favicon = null;
    },
    async getList() {
      await this.axios
        .post(`${this.$baseUrl}/Team/list/name`, this.filter)
        .then((data) => {
          if (data.result == 1) {
            this.teamList = this.teamList.concat(data.detail.data);
          }
        });
    },
    async getData() {
      this.isLoadingData = true;
      await this.axios
        .get(`${this.$baseUrl}/setting/chat-setting/get`)
        .then((data) => {
          this.isLoadingData = false;
          if (data.result == 1) {
            this.form = data.detail;
          }
        });
    },
    async handleSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$error) {
        return;
      }

      this.$store.commit("UPDATE_MAIN_LOADING", true);
      this.isDisabled = true;
      await this.axios
        .post(`${this.$baseUrl}/setting/chat-setting/update`, this.form)
        .then((data) => {
          this.$store.commit("UPDATE_MAIN_LOADING", false);
          this.isDisabled = false;
          if (data.result == 1) {
            this.$store.dispatch("flowBuilder/fetchLogoBrand");
            this.getData();
            this.$store.commit("UPDATE_GLOBAL_ALERT", {
              isShow: true,
              msg: data.message,
            });
          } else
            this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
              isShow: true,
              msg: data.detail,
            });
        })
        .catch((err) => {
          this.isDisabled = false;
          this.$store.commit("UPDATE_GLOBAL_ALERT_ERROR", {
            isShow: true,
            msg: err.message,
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .btn-select {
  width: 180px !important;
}

::v-deep .label {
  font-weight: normal;
  font-size: 16px !important;
  margin-bottom: 8px !important;
}
.dropdown-date-custom-text {
  color: #404040;
  font-size: 16px;
  margin-bottom: 2px;
  font-weight: 700;
}
</style>
